import { createThunk, model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { Api } from '@api';
import { TopCategoryModel } from './TopCategoryModel';

export class Categories extends Model({
  list: types.maybe(TopCategoryModel),
}) {
  get filters() {
    return this.list ? this.list.children : [];
  }

  get appliedFilterNames() {
    // Retrieving selected parent categories with children
    const categories = this.filters.filter(
      (i) => i.canBeAppliedAsFilter,
    );

    if (categories.length === 0) {
      return null;
    }

    return categories.map((i) => i.selectedNames).flat();
  }

  get appliedFilterIds() {
    return this.filters
      .filter((i) => i.canBeAppliedAsFilter)
      .map((i) => i.selectedIds)
      .flat();
  }

  applyFilters() {
    this.list?.children.forEach((i) => i.applyPreSelection());
  }

  clearFilters() {
    this.list?.children.forEach((i) => i.clearSelection());
  }

  resetPreSelection() {
    this.list?.children.forEach((i) => i.resetPreSelection());
  }

  // TODO: fix type
  private _setCategories(v: any) {
    this.list = v;
  }

  fetch = createThunk(() => {
    return async function fetch(this: Categories) {
      const res = await Api.Hub.getCategories();

      this._setCategories(res.data);
    };
  });
}

export const CategoriesModel = model(Categories);
